import React, { useState } from "react";
import emailjs from "emailjs-com";
import { FaXTwitter } from "react-icons/fa6";
import facebook from "../../assets/fb.png";
import instagram from "../../assets/instagram.png";
import "./Contact.css";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    subject: "General Inquiry",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(name, value);
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const templateParams = {
      to_name: "E-TECHNO", // Replace with recipient name
      from_name: `${formData.firstName} ${formData.lastName}`,
      email: formData.email,
      phone: formData.phone,
      subject: formData.subject,
      message: formData.message,
    };
    console.log(templateParams);
    emailjs
      .send(
        "service_s3k5vcw", 
        "template_bn59add", 
        templateParams,
        "9ZRaTReespHp7TbQz" 
      )
      .then(
        (response) => {
          console.log("SUCCESS!", response.status, response.text);
          alert("Your message has been sent!");
        },
        (error) => {
          console.error("FAILED...", error);
          alert("Failed to send the message. Please try again later.");
        }
      );
  };

  return (
    <div className="contact-container">
      <div className="contact-info">
        <h2>Contact Information</h2>
        <ul>
          <li>
            <span className="icon">📞</span>
            +91 9811133790
          </li>
          <li>
            <span className="icon">✉️</span>
            contact@etechnoedu.org
          </li>
          <li>
            <span className="icon">📍</span>
            India
          </li>
        </ul>
        {/* Social Icons */}
        <div className="social-icons">
          <a href="https://x.com/etechnoedu?s=21">
            <span className="social-icon">
              <FaXTwitter />
            </span>
          </a>
          <a
            href="https://www.instagram.com/e_techno_educationa/profilecard/?igsh=ZzJka2NscnFvN2pj"
            className="insta"
          >
            <span className="social-icon">
              <img src={instagram} alt="instagram" />
            </span>
          </a>
          <a href="https://www.facebook.com/share/zMPFJwUmQQf5DyuR/?mibextid=LQQJ4d">
            <span className="social-icon">
              <img src={facebook} alt="facebook" />
            </span>
          </a>
        </div>
      </div>

      {/* Contact Form Section */}
      <div className="contact-form">
        <form onSubmit={handleSubmit}>
          {/* Row for Name */}
          <div className="form-row">
            <div className="form-group">
              <input
                type="text"
                id="firstName"
                name="firstName"
                placeholder="First Name"
                value={formData.firstName}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <input
                type="text"
                id="lastName"
                name="lastName"
                placeholder="Last Name"
                value={formData.lastName}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          {/* Row for Email and Phone */}
          <div className="form-row">
            <div className="form-group">
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <input
                type="text"
                id="phone"
                name="phone"
                placeholder="+91"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          {/* Subject Selection */}
          <div className="form-row">
            <label>Select Subject</label>
            <div className="radio-options">
              <label>
                <input
                  type="radio"
                  name="subject"
                  value="General Inquiry"
                  checked={formData.subject === "General Inquiry"}
                  onChange={handleChange}
                />
                General Inquiry
              </label>
              <label>
                <input
                  type="radio"
                  name="subject"
                  value="Donations"
                  onChange={handleChange}
                />
                Donations
              </label>
              <label>
                <input
                  type="radio"
                  name="subject"
                  value="Membership"
                  onChange={handleChange}
                />
                Membership
              </label>
              <label>
                <input
                  type="radio"
                  name="subject"
                  value="Volunteering"
                  onChange={handleChange}
                />
                Volunteering
              </label>
            </div>
          </div>

          {/* Message */}
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea className="message-box"
                id="message"
                name="message"
                placeholder="Write your message"
                value={formData.message}
                onChange={handleChange}
                style={{ border: "1px solid white" }}
                required
              ></textarea>
            </div>
          </div>

          {/* Submit Button */}
          <div className="btn-div">
            <button type="submit" className="submit-btn">
              Send
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContactForm;
